var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c("b-row", { staticClass: "topInfoRow" }, [
        _c(
          "div",
          { staticClass: "card noBoxShadow col6-left" },
          [
            _c("div", [
              _c("h4", { staticClass: "marginB-5" }, [
                _vm._v(_vm._s(_vm.logs ? _vm.logs.length : 0))
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("Logs")])
            ]),
            _vm._v(" "),
            _c(
              "b-btn",
              {
                attrs: { variant: "primary" },
                on: { click: _vm.clearTestData }
              },
              [_vm._v("Clear Test Data")]
            ),
            _vm._v(" "),
            _vm.clearTestDataTimestamp ||
            _vm.getOrganizationLastClearedTimestamp()
              ? _c("p", [
                  _vm._v(
                    "Last cleared: " +
                      _vm._s(_vm.formatTimestamp(_vm.clearTestDataTimestamp))
                  )
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card noBoxShadow col6-right" },
          [
            _c("div", [
              _c("h4", { staticClass: "marginB-5" }, [_vm._v("Search")]),
              _vm._v(" "),
              _c("p", [_vm._v("By User Email, Log Type, or Object ID")])
            ]),
            _vm._v(" "),
            _c(
              "b-input-group",
              { staticClass: "searchClearInput" },
              [
                _c("b-form-input", {
                  attrs: { placeholder: "Type to Search" },
                  on: { input: _vm.handleFilterChange },
                  model: {
                    value: _vm.filter.nameText,
                    callback: function($$v) {
                      _vm.$set(_vm.filter, "nameText", $$v)
                    },
                    expression: "filter.nameText"
                  }
                }),
                _vm._v(" "),
                _c(
                  "b-input-group-addon",
                  [
                    _c(
                      "b-btn",
                      {
                        attrs: { disabled: !_vm.filter.nameText },
                        on: { click: _vm.clearFilter }
                      },
                      [_vm._v("Clear")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "b-btn",
            {
              directives: [
                {
                  name: "b-toggle",
                  rawName: "v-b-toggle.collapse1",
                  modifiers: { collapse1: true }
                }
              ],
              staticClass: "filterBtn bgDarkBlue",
              attrs: { variant: "primary" }
            },
            [
              _vm._v("Filters"),
              _c("img", {
                staticStyle: { "margin-left": "14px" },
                attrs: {
                  src: require("../../../../static/img/filterIcon.png"),
                  width: "17px",
                  height: "11px"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "b-collapse",
            {
              staticClass: "filterCollapse marginB-62",
              attrs: { id: "collapse1" }
            },
            [
              _c("b-card", [
                _c(
                  "div",
                  { staticClass: "div1" },
                  [
                    _c("span", [_vm._v("Filters")]),
                    _vm._v(" "),
                    _c("b-btn", { on: { click: _vm.resetFilters } }, [
                      _vm._v("Reset to defaults")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "div2" },
                  [
                    _c(
                      "b-form-group",
                      { staticClass: "field", attrs: { label: "Date" } },
                      [
                        _c("datepicker", {
                          attrs: {
                            "initial-view": "year",
                            id: "filter_date",
                            placeholder: "Select Date",
                            format: this.$dateFormatter,
                            "disabled-dates": { from: new Date() },
                            "clear-button": ""
                          },
                          model: {
                            value: _vm.filter.date,
                            callback: function($$v) {
                              _vm.$set(_vm.filter, "date", $$v)
                            },
                            expression: "filter.date"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      { staticClass: "field", attrs: { label: "Log Type" } },
                      [
                        _c(
                          "b-form-select",
                          {
                            staticClass: "greySelect",
                            model: {
                              value: _vm.filter.logType,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "logType", $$v)
                              },
                              expression: "filter.logType"
                            }
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: { slot: "first" },
                                domProps: { value: null },
                                slot: "first"
                              },
                              [_vm._v("Choose...")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Create - Assessment" } },
                              [_vm._v("Create - Assessment")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Create - CSE-IT" } },
                              [_vm._v("Create - CSE-IT")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Create - Group" } },
                              [_vm._v("Create - Group")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Create - Location" } },
                              [_vm._v("Create - Location")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Create - Note" } },
                              [_vm._v("Create - Note")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Create - Organization" } },
                              [_vm._v("Create - Organization")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Create - Person" } },
                              [_vm._v("Create - Person")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              {
                                attrs: { value: "Create - Person External ID" }
                              },
                              [_vm._v("Create - Person External ID")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Create - Program" } },
                              [_vm._v("Create - Program")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              {
                                attrs: { value: "Create - Sharing Assessment" }
                              },
                              [_vm._v("Create - Sharing Assessment")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Create - Sharing CSE-IT" } },
                              [_vm._v("Create - Sharing CSE-IT")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Create - Sharing Note" } },
                              [_vm._v("Create - Sharing Note")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Create - Sharing Person" } },
                              [_vm._v("Create - Sharing Person")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Create - User Member" } },
                              [_vm._v("Create - User Member")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "ERROR - Create User" } },
                              [_vm._v("ERROR - Create User")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              {
                                attrs: { value: "ERROR - Update User Member" }
                              },
                              [_vm._v("ERROR - Update User Member")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Login - Success" } },
                              [_vm._v("Login - Success")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Logout - Success" } },
                              [_vm._v("Logout - Success")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Update - Assessment" } },
                              [_vm._v("Update - Assessment")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Update - CSE-IT" } },
                              [_vm._v("Update - CSE-IT")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Update - Group" } },
                              [_vm._v("Update - Group")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Update - Location" } },
                              [_vm._v("Update - Location")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Update - Note" } },
                              [_vm._v("Update - Note")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Update - Organization" } },
                              [_vm._v("Update - Organization")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Update - Person" } },
                              [_vm._v("Update - Person")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              {
                                attrs: { value: "Update - Person External ID" }
                              },
                              [_vm._v("Update - Person External ID")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Update - Program" } },
                              [_vm._v("Update - Program")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              {
                                attrs: { value: "Update - Sharing Assessment" }
                              },
                              [_vm._v("Update - Sharing Assessment")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Update - Sharing CSE-IT" } },
                              [_vm._v("Update - Sharing CSE-IT")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Update - Sharing Note" } },
                              [_vm._v("Update - Sharing Note")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Update - Sharing Person" } },
                              [_vm._v("Update - Sharing Person")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Update - User Member" } },
                              [_vm._v("Update - User Member")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Update - User" } },
                              [_vm._v("Update - User")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "View - Assessment" } },
                              [_vm._v("View - Assessment")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "View - CSE-IT" } },
                              [_vm._v("View - CSE-IT")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "View - Person" } },
                              [_vm._v("View - Person")]
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      { staticClass: "field", attrs: { label: "Sys Alert" } },
                      [
                        _c(
                          "b-form-select",
                          {
                            staticClass: "greySelect",
                            model: {
                              value: _vm.filter.sysAlert,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "sysAlert", $$v)
                              },
                              expression: "filter.sysAlert"
                            }
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: { slot: "first" },
                                domProps: { value: null },
                                slot: "first"
                              },
                              [_vm._v("Choose...")]
                            ),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "true" } }, [
                              _vm._v("true")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "false" } }, [
                              _vm._v("false")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "h2",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.finishedLoading,
                  expression: "!finishedLoading"
                }
              ],
              staticClass: "u-padding-bottom-20"
            },
            [_vm._v("Loading, please wait ...")]
          ),
          _vm._v(" "),
          _c("pulse-loader", {
            attrs: {
              loading: !_vm.finishedLoading,
              color: _vm.spinnerColor,
              size: _vm.spinnerSize
            }
          }),
          _vm._v(" "),
          _c("b-table", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.finishedLoading,
                expression: "finishedLoading"
              }
            ],
            attrs: {
              filter: _vm.filter,
              "filter-function": _vm.searchFilter,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
              "sort-direction": _vm.sortDirection,
              hover: true,
              striped: true,
              bordered: false,
              small: true,
              fixed: true,
              responsive: "sm",
              items: _vm.logs,
              fields: _vm.getTableFields(),
              "per-page": 20,
              "current-page": _vm.currentPage
            },
            on: {
              "update:sortBy": function($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function($event) {
                _vm.sortDesc = $event
              },
              filtered: _vm.onFiltered
            },
            scopedSlots: _vm._u([
              {
                key: "logDTS",
                fn: function(item) {
                  return _c("div", {}, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.formatTimestamp(item.value)))
                    ])
                  ])
                }
              },
              {
                key: "objectID",
                fn: function(item) {
                  return _c(
                    "div",
                    {},
                    [
                      _c(
                        "b-link",
                        {
                          on: {
                            click: function($event) {
                              return _vm.goObject(item.value)
                            }
                          }
                        },
                        [_c("span", {}, [_vm._v(_vm._s(item.value))])]
                      )
                    ],
                    1
                  )
                }
              },
              {
                key: "payload",
                fn: function(item) {
                  return _c(
                    "div",
                    {},
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "bgDarkBlue",
                          attrs: { size: "sm", variant: "primary" },
                          on: { click: item.toggleDetails }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.detailsShowing ? "Hide" : "Show") +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                }
              },
              {
                key: "row-details",
                fn: function(data) {
                  return _c(
                    "div",
                    {},
                    [
                      _c("b-card", [
                        _vm._v(
                          "\n              " +
                            _vm._s(data.item.payload) +
                            "\n          "
                        )
                      ])
                    ],
                    1
                  )
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("b-pagination", {
            attrs: {
              "total-rows": _vm.getRowCount(_vm.logs),
              "prev-text": "Prev",
              "next-text": "Next",
              "current-page": _vm.currentPage
            },
            model: {
              value: _vm.currentPage,
              callback: function($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b52c797", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b52c797","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/Logs.vue
// module id = 1926
// module chunks = 0